import React, { useEffect, useState } from 'react';
import HeadTitle from '../../components/HeadTitle';
import SubscriptionPlans from '../../components/financials/SubscriptionPlans';
import SubscribedUserList from '../../components/financials/SubscribedUserList';
import SearchFilter from '../../components/analytics-and-insights/SearchFilter';
import FinancialsPlansSkeleton from '../financial-container/FinancialsPlansSkeleton';

// Subscription page. Intentionally a subscription-only subset of the Financials
// page: it renders SubscriptionPlans + SubscribedUserList but NOT RevenueAnalytics,
// so a Moderator can manage subscriptions without seeing revenue streams. The full
// Financials page (with revenue) stays Admin-only at /financials.
const Subscription = () => {
  const [loading, setLoading] = useState(true);
  const [components] = useState([
    {
      id: 1,
      imageSrc: '/assets/images/admin-panel/financials.svg',
      text: 'Subscription',
      description:
        'Insights into subscription plans and the members subscribed to them.',
    },
  ]);

  useEffect(() => {
    // Simulate API load time
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500);
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <FinancialsPlansSkeleton />;
  }

  return (
    <div>
      {components.map((component) => (
        <HeadTitle
          key={component.id}
          imageSrc={component.imageSrc}
          text={component.text}
          description={component.description}
        />
      ))}
      <SearchFilter isHideUserManagement={false} />
      <div className="">
        <SubscriptionPlans hideRevenue />
      </div>
      <div className="py-32">
        {/* lifetimeOnLoad: this screen answers "who has ever subscribed", so it opens on the
            full history and only applies the date picker once the user moves it. */}
        <SubscribedUserList hideRevenue lifetimeOnLoad />
      </div>
    </div>
  );
};

export default Subscription;
